export const HistorySingle = ({ children }) => (
  <div className="tennders-table-zebra text-12 lh-1-3">
    <div>
      {children}
    </div>
  </div>
)
